/** 从 URL 提取参数：优先 searchParams，兼容 ``?id=xxx?token=yyy`` 等异常回跳格式 */
function extractUrlParam(href, name) {
  try {
    const fromParams = new URL(href).searchParams.get(name);
    if (fromParams) return fromParams;
  } catch {
    // ignore
  }
  const re = new RegExp(`(?:^|[?&])${name}=([^&#]+)`, "i");
  const match = href.match(re);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

/** 从 URL 中移除指定参数（含嵌在 query 值里的 ``?token=``） */
function stripUrlParam(href, name) {
  return href.replace(new RegExp(`([?&])${name}=[^&#]*`, "gi"), "");
}

/** Capture SSO token from URL after WeChat redirect and persist it. */
export function captureAuthTokenFromUrl() {
  try {
    const href = window.location.href;
    const token = extractUrlParam(href, "token");
    const avatar = extractUrlParam(href, "avatar");
    if (!token && !avatar) return false;

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("jsessionid", token);
    }

    if (avatar) {
      localStorage.setItem("digitwai_user_avatar", avatar);
    }

    let clean = stripUrlParam(href, "token");
    clean = stripUrlParam(clean, "avatar");
    // 清理可能残留的 ``?&`` / 末尾 ``?``
    clean = clean.replace(/\?&/g, "?").replace(/[?&]$/, "");
    window.history.replaceState({}, "", clean);
    return Boolean(token);
  } catch {
    return false;
  }
}

export function getStoredAuthToken() {
  return localStorage.getItem("token") || localStorage.getItem("jsessionid");
}

/** 清理 URL 回跳 token 中可能附带的 & / # 后缀 */
export function sanitizeAuthToken(raw) {
  if (!raw) return "";
  return String(raw).trim().split("&")[0].split("#")[0];
}

export function getSanitizedAuthToken() {
  let token = sanitizeAuthToken(getStoredAuthToken() || "");
  if (!token) {
    captureAuthTokenFromUrl();
    token = sanitizeAuthToken(getStoredAuthToken() || "");
  }
  return token;
}

/** 与 comAjax / digitwai-ai training 代理一致的鉴权请求头 */
export function buildAuthRequestHeaders(extra = {}) {
  const headers = { Accept: "application/json", language: "zh-cn", ...extra };
  const token = getSanitizedAuthToken();
  if (token) {
    headers.token = token;
    headers.Authorization = token;
  }
  return headers;
}

export function clearStoredAuthToken() {
  localStorage.removeItem("token");
  localStorage.removeItem("jsessionid");
}

export function getLoginUrl(serviceUrl = window.location.href) {
  return `/login?service=${encodeURIComponent(serviceUrl)}`;
}

/** 当前是否在登录页（避免重定向死循环） */
export function isOnLoginPage() {
  try {
    return /^\/login\/?$/i.test(window.location.pathname || "");
  } catch {
    return false;
  }
}

/**
 * 需要登录才能使用学习页：无 token 时跳转登录。
 * @returns {boolean} true=已登录可继续；false=已触发跳转
 */
export function ensureAuthenticatedOrRedirect() {
  captureAuthTokenFromUrl();
  if (getSanitizedAuthToken()) return true;
  if (isOnLoginPage()) return false;
  window.location.replace(getLoginUrl(window.location.href));
  return false;
}

/** 登录失效：清 token 并跳转登录页 */
export function redirectToLogin(serviceUrl = window.location.href) {
  clearStoredAuthToken();
  if (isOnLoginPage()) return;
  window.location.replace(getLoginUrl(serviceUrl));
}
